import React, { useState , useEffect} from 'react'
import { useLocation } from 'react-router-dom';
import {
  Dropdown,
  Space,
  Menu,
  Button,
  Switch,
  Form,
  notification,
  Badge,
  Drawer,
  Modal,
  Input
} from "antd"
import { LogoutOutlined, RadarChartOutlined, SwapOutlined, CaretDownOutlined, MenuOutlined } from '@ant-design/icons'

import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import SettingService from '../../../services/settingService';
import ReactCodeInput from 'react-code-input';
import LoginService from '../../../services/loginService'
import ChatRealTImeEvent from './ChatRealTImeEvent';

import { handleSignout, setMenu } from "../../../actions";
import { HOST } from '../../../constants/url';
import { routes } from "App"
import { USER_DETAILS_UPDATE } from '../../../constants/member';
import { ALL_PERMISSION, hasPermission, hasPermissionWithSetting, NOT_ENABLE_KEY, warningPermission } from '../../../constants/permission';
import StationIntroduceService from 'services/stationIntroduceService';
import "./header.scss"
import themeIcons from 'assets/Theme';
import { useModalDirectLinkContext } from 'components/ModalDirectLink';
import BasicButtonPrimary from 'components/BasicButtonPrimary';
import { IconHomeMenu } from 'assets/icons/home';
import { IconHomeDanhBa } from 'assets/icons/home';
import { IconHomeChat } from 'assets/icons/home';
import { IconHomeCaiDat } from 'assets/icons/home';
import { IconHomeTrungTamTroGiup } from 'assets/icons/home';

const HeaderAction = ({ Icon, path, notification, count = 1, link, action=()=>{} }) => { // action ở đây là hành động đi kèm trong handleClick, trường hợp này là dispatch để menu ẩn đi
  const { setUrlForModalDirectLink } = useModalDirectLinkContext();

  const history = useHistory();
  const handleClick = async () => {
    if (path !== undefined) {
      action()
      history.push(path)
    } else {
      setUrlForModalDirectLink(link)
    }
  }
  return (
    <div onClick={() => handleClick()}>
      {notification ?
        <Badge
          count={
            <div className='header__badge__box'>

            </div>
          }
          offset={[-3, 6]}
          className="header__action__badge"
        >
          <Icon height={45} width={45} />
        </Badge> :
        <Icon height={45} width={45} />
      }
    </div>
  )
}

function Header({
  userData, isHeaderTextOnly,
  isAuth
}) {
  const { t: translate } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch();
  const location = useLocation();
  const user = useSelector(state => state.member)
  const { notification } = useSelector(state => state.chat);
  const path = location.pathname;
  const isShowRealTimeChat = path !== "/chat" && user.isUserLoggedIn;
  const [isOpenModalChangePassword, setIsOpenModalChangePassword] = useState(false)
  const [isOpenModal2FA, setIsOpenModal2FA] = useState(false)
  const [listLinkCSKH, setListLinkCSKH] = useState({});
  const menuData = useSelector((state) => state?.common?.menu)
  const setting = useSelector((state) => state.setting);


  const getMenu = (styleWidth) => {
    return (
        <Menu style={{ width: styleWidth || "175px" }}>
          {/* {
            FEATURE.map((item) => (
              <Menu.Item
                          onClick={
                            item.href === "/question"
                              ? gitbook
                              : () => {
                                  if (!item.isNoHref) {
                                    _onClick(item.href);
                                  }
                                }
                          }
                          key={Math.random()}
                          className='mobies_text'
                        >
                          <div>
                            <span className='mobies_icon'>
                              {item?.icon || <></>}
                            </span>
                            <span className='mobies_text'>
                              {item.name.toUpperCase()}
                            </span>
                          </div>
                        </Menu.Item>
            ))
          } */}
          <Menu.Item
            onClick={() => setIsOpenModalChangePassword(true)}
            className='mobies_text'
          >
            <span className='mobies_icon'><SwapOutlined /></span>
            {translate("setting.changePass")}
          </Menu.Item>
          <Menu.Item
            onClick={() => setIsOpenModal2FA(true)}
            className='mobies_text'
          >
            <div className='w-100 d-flex justify-content-between'>
              <div>
                <span className='mobies_icon'><RadarChartOutlined /></span>
                <span className='mobies_text'>2FA OTP</span>
              </div>
              <div>
                <Switch checked={user.twoFAEnable ? true : false} />
              </div>
            </div>
          </Menu.Item>
          <Menu.Item
            onClick={() => {
              dispatch(handleSignout(() => {
                history.push("/login")
              }))
            }}
            className='mobies_text'
          >
            <span className='mobies_icon'><LogoutOutlined /></span>
            {translate("header.logout")}
          </Menu.Item>
        </Menu>
    )
  }

  const getMenuPc = (styleWidth) => {
    return (
        <Menu style={{ width: styleWidth || "200px" }} className='popover_width'>
          <Menu.Item
            onClick={() => setIsOpenModalChangePassword(true)}
          >
            <div className='d-flex gap-2 align-items-center'>
              <SwapOutlined style={{fontSize : 20}}/>
              <span>{translate("setting.changePass")}</span>
            </div>
          </Menu.Item>
          <Menu.Item
            onClick={() => setIsOpenModal2FA(true)}
          >
            <div className='d-flex gap-2 align-items-center'>
              <RadarChartOutlined style={{fontSize : 20}}/>
              <div className='w-100 d-flex justify-content-between'>
                <div>
                  <span >2FA OTP</span>
                </div>
                <div>
                  <Switch checked={user.twoFAEnable ? true : false} />
                </div>
              </div>
            </div>
          </Menu.Item>
          <Menu.Item
            onClick={() => {
              dispatch(handleSignout(() => {
                history.push("/login")
              }))
            }}
          >
            <div className='d-flex gap-2 align-items-center'>
              <LogoutOutlined style={{fontSize : 20}} className='text-error'/>
              <span className='text-error'>{translate("header.logout")}</span>
            </div>
          </Menu.Item>
        </Menu>
    )
  }

  const MenuPc = () => {
    return (
      <Dropdown overlay={getMenuPc()} trigger={['click']}>
        <div>
           <span className='header-left-title'>{getUserName()}</span>
          <CaretDownOutlined />
        </div>
      </Dropdown>
    )
  }

  const MenuMobile = () => {
    const [isOpen, setIsOpen] = useState(false);
    return (
      <>
        <div onClick={() => setIsOpen(true)}>
          <MenuOutlined  style={{fontSize : 24}}/>
        </div>
        <ModalMobile
          isOpen={isOpen}
          toggleModal={() => setIsOpen(prev => !prev)}
          menu={getMenu("100%")}
        />
      </>
    )
  }

  const getUserName = () => {
    if (
      (userData.firstName)
    ) {
      return userData.firstName
    } else if (userData.email) {
      return userData.email
    } else if (userData.phoneNumber) {
      return userData.phoneNumber
    } else {
      return userData.username
    }
  }

  const onChange2FASecurity = (isOn) => {
    SettingService.UpdateUser({
      id: user.appUserId,
      data: {
        twoFAEnable: isOn ? 0 : 1
      }
    }).then(result => {
      if (!result) {
        notification.error({
          message: "",
          description: translate("accreditation.updateError")
        })
      } else {
        dispatch({
          type: USER_DETAILS_UPDATE,
          data: {
            ...user,
            twoFAEnable: isOn ? 0 : 1
          }
        })
      }
    })
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if(isAuth){
      getLinkCSKH();
    }
  }, []);

  function getLinkCSKH() {
    StationIntroduceService.getLinkCSKH({})
      .then((result) => {
        setListLinkCSKH(result);
        dispatch(setMenu({
          ...menuData,
          stationSetting: result
        }))
      })
      .catch(() => {
        translate("introduce.importFailed");
      });
  }

  const optionHeaderRender = () => {
    const options = [
      {
        icon: IconHomeDanhBa,
        path: routes.phonebook.path,
        permissions: ALL_PERMISSION.MANAGE_PHONEBOOK.permission,
        keyEnable: ALL_PERMISSION.MANAGE_PHONEBOOK.keyEnable,
        isHidden: process.env.REACT_APP_THEME_NAME  === "HCMTAX"
      },
      {
        icon: IconHomeCaiDat,
        path: routes.setting.path,
        permissions: ALL_PERMISSION.MANAGE_SETTINGS.permission,
        keyEnable: ALL_PERMISSION.MANAGE_SETTINGS.keyEnable
      },
      {
        icon: IconHomeTrungTamTroGiup,
        link: "https://ttdk-organization.gitbook.io/huong-dan-quan-ly-trung-tam/",
        notification: notification,
        permissions: ALL_PERMISSION.MANAGE_GUIDE.permission,
        keyEnable: ALL_PERMISSION.MANAGE_GUIDE.keyEnable,
        isHidden: process.env.REACT_APP_THEME_NAME  === "HCMTAX"
      },
      {
        icon: IconHomeChat,
        link: listLinkCSKH.chatLinkEmployeeToUser,
        notification: notification,
        permissions: ALL_PERMISSION.MANAGE_CHAT.permission,
        keyEnable: ALL_PERMISSION.MANAGE_CHAT.keyEnable,
        isHidden: process.env.REACT_APP_THEME_NAME  === "HCMTAX"
      },
      // {
      //   icon: BellOutlined,
      //   path: "/notification",
      // },
    ]
      options.forEach(item =>
        warningPermission(item.permissions)
      );

      // Sử dụng hasPermissionWithSetting để kiểm tra cả quyền và setting
      let filterOptionsPermission = options.filter(item =>
        hasPermissionWithSetting(item.permissions, item.keyEnable, setting)
      );
      filterOptionsPermission = filterOptionsPermission.filter(item =>
        !item.isHidden
      );

      return filterOptionsPermission
  }

  return (
    <header className={`header align-items-center px-2 ${isHeaderTextOnly ? "flex-center" : ""}`}>
      {isShowRealTimeChat &&  <ChatRealTImeEvent />}
      <div className='header-left d-flex align-items-center gap-3'>
        {
          isAuth &&
            <IconHomeMenu onClick={()=>{
              const isHomePage = window.location.pathname === '/';

              if (isHomePage) {
                // Nếu đang ở trang home, toggle menu
                dispatch(setMenu({
                  ...menuData,
                  isShow: !menuData.isShow
                }))
              } else {
                // Nếu đang ở trang khác, đảm bảo menu sẽ hiển thị trước khi navigate
                dispatch(setMenu({
                  ...menuData,
                  isShow: true
                }))
                // Navigate về home
                history.push('/');
              }
            }}
            />
        }
        {
          !isAuth &&
          <a href='/'>
            {/* <p className='d-flex d-md-none mb-0 header-left-title'>{getUserName()}</p> */}
            <div style={{ filter: (!process.env.REACT_APP_THEME_NAME || process.env.REACT_APP_THEME_NAME === 'TTDK') ? "brightness(0) invert(1)" : "none" }}>{themeIcons.Logo}</div>
          </a>
        }
      </div>
      {
        !isHeaderTextOnly ? (
          <div className='header-right'>
            {
              (isAuth || user?.username) ? (
                <Space>
                  <Space size={20} className="header__box hidden_screen_1000px">
                    {
                      optionHeaderRender().map((item, index) => <HeaderAction 
                        key={index}
                        Icon={item.icon}
                        link={item.link}
                        notification={item.notification}
                        path={item.path}
                        action={()=>{
                          dispatch(setMenu({
                            ...menuData,
                            isShow: false
                          }))
                        }}
                      />)
                    }
                    {/* <HeaderAction Icon={} path="/phonebook" />
                    {isCheckedSetting && 
                    <HeaderAction Icon={SettingOutlined} path="/setting" />
                    }
                    {isCheckedGuide && 
                    <HeaderAction Icon={QuestionCircleOutlined} link={""} notification={notification} />
                    }
                    <HeaderAction Icon={MessageOutlined} link={} notification={notification} />
                    <HeaderAction Icon={BellOutlined} path="" /> */}
                  </Space>
                  <>
                    <div className=''>{translate("hello")},</div>
                    <div className=''>
                      <MenuPc />
                    </div>
                    {/* <div className='d-flex d-md-none'>
                      <MenuMobile />
                    </div> */}
                  </>
                </Space>
              ) : (
                <Button
                  onClick={() => {
                    history.push("/login")
                  }}
                  type="default"
                  className='my-2'
                >{translate("landing.login")}</Button>
              )
            }
          </div>
        ) : (
          <></>
        )
      }
      <ModalChangePassword
        isOpen={isOpenModalChangePassword}
        toggleModal={() => setIsOpenModalChangePassword(!isOpenModalChangePassword)}
        user={user}
      />
      <Modal2FACode
        isOpen={isOpenModal2FA}
        toggleModal={() => setIsOpenModal2FA(!isOpenModal2FA)}
        onChange2FASecurity={onChange2FASecurity}
        user={user}
      />
    </header>
  )
}

const ModalMobile = ({ isOpen , menu , toggleModal }) => {
  const { username } = useSelector((state) => state.member);
  const { t: translation } = useTranslation()
  return (
    <Drawer
      visible={isOpen}
      title={`${translation("header.hello")}, ${username}`}
      onClose={toggleModal}
      footer={<span className='ant-drawer-title'>version web : </span>}
      width="100%"
      className="drawer"
    >
      {menu}
    </Drawer>
  )
}

const ModalChangePassword = ({ isOpen, toggleModal, user }) => {
  const { t: translation } = useTranslation()
  const [form] = Form.useForm()

  const onFinish = (values) => {
    LoginService.changeUserPassword(values).then(result => {
      if (result && result.isSuccess) {
        notification.success({
          message: "",
          description: translation("listCustomers.success", {
            type: translation('setting.changePass')
          })
        })
        form.resetFields()
        toggleModal()
      } else {
        notification.error({
          message: "",
          description: translation("listCustomers.failed", {
            type: translation('setting.changePass')
          })
        })
      }
    })
  }
  return (
    <Modal
      visible={isOpen}
      title={translation('setting.changePass')}
      onCancel={toggleModal}
      footer={null}
    >
      <Form initialValues={{ username: user?.username || "" }} form={form} onFinish={onFinish}>

        <label>{translation('landing.currentPassword')}</label>
        <Form.Item
          name="password"
          rules={[{
            message: `${translation('isReq')}`,
            required: true
          }]}
        >
          <Input autoFocus placeholder={translation('landing.currentPassword')} type="password" />
        </Form.Item>

        <label>{translation('landing.newPassword')}</label>
        <Form.Item
          name="newPassword"
          rules={[{
            message: `${translation('isReq')}`,
            required: true
          }]}
        >
          <Input placeholder={translation('landing.newPassword')} type="password" />
        </Form.Item>

        <Form.Item>
          <BasicButtonPrimary
            htmlType="submit"
            text={translation('landing.confirm')}
          />
          {/* <Button type="primary" htmlType="submit">
            {translation('landing.confirm')}
          </Button> */}
        </Form.Item>
      </Form>
    </Modal>
  )
}

const Modal2FACode = ({ isOpen, toggleModal, onChange2FASecurity, user }) => {
  const [isValid, setIsValid] = useState(true)
  const { t: translation } = useTranslation()
  const inputStyle = {
    "fontFamily": "monospace",
    "MozAppearance": "textfield",
    "borderRadius": "6px",
    "border": "1px solid",
    "boxShadow": "0px 0px 10px 0px rgba(0,0,0,.10)",
    "margin": "4px",
    "textAlign": "center",
    "width": "40px",
    "height": "40px",
    "fontSize": "32px",
    "boxSizing": "border-box",
    "color": "black",
    "backgroundColor": "white",
    "borderColor": "lightgrey"
  }

  const inputInvalidStyle = {
    ...inputStyle,
    "border": "1px solid rgb(238, 211, 215)",
    "boxShadow": "rgb(0 0 0 / 10%) 0px 0px 10px 0px",
    "color": "rgb(185, 74, 72)",
    "backgroundColor": "rgb(242, 222, 222)"
  }

  const typeCode = (code) => {
    if (code.length === 6) {
      SettingService.verifyingUserCode({
        "otpCode": code,
        "id": user.appUserId
      }).then(result => {
        if (result) {
          onChange2FASecurity(user.twoFAEnable)
          notification.success({
            message: "",
            description: translation('inspectionProcess.updateSuccess')
          })
        } else {
          notification.error({
            message: "",
            description: translation('setting.twoFAError')
          })
          setIsValid(false)
        }
      })
    }
  }

  return (
    <Modal
      visible={isOpen}
      title={translation('landing.twoFATitle')}
      onCancel={toggleModal}
      footer={null}
    >
      <div>
        <i>{translation('landing.twoFANote')}</i>
      </div>
      <div className='d-flex justify-content-center'>
        <img
          src={`${HOST}/AppUsers/get2FACode?id=${user.appUserId}`}
          height='200'
          alt=''
        />
      </div>
      <div className="mb-1 mt-3 text-center">
        <strong>
          {translation('landing.twoFASubTitle')}
        </strong>
      </div>
      <ReactCodeInput
        type='text'
        fields={6}
        inputStyle={inputStyle}
        inputStyleInvalid={inputInvalidStyle}
        isValid={isValid}
        onChange={typeCode}
        autoFocus
      />
    </Modal>
  )
}

export default Header